import { createRootRoute, Outlet } from '@tanstack/react-router'
import Logo from '@tandem/ui/Тандем.svg?react'
import Devtools from '../Devtools'
import $ from '../App.css'

export const Route = createRootRoute({
  component: RootLayout
})

function RootLayout() {
  return (
    <div class={$.layout}>
      <header className={$.header}>
        <div className={$.container}>
          <a href='/' className={$.logo}>
            <Logo />
          </a>
          <nav>
            <a href={`${env.BUSINESS_APP_URL}/login`} className={$.cta}>
              Войти
            </a>
          </nav>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className={$.footer}>
        <div className={$.container}>
          <p>&copy; 2026 ООО «Тандем Ритейл»</p>
        </div>
      </footer>

      {import.meta.env.DEV && <Devtools />}
    </div>
  )
}
